import { BrowserRouter } from "react-router-dom";
import { configure } from "mobx";
import { MantineProvider } from "@mantine/core";
import { Notifications } from "@mantine/notifications";
import { AudioProvider } from "./context/audio";
import { theme } from "./theme/mantine-theme";
import { colorSchemeManager } from "./theme/color-scheme";
import "@mantine/core/styles.css";
import "@mantine/notifications/styles.css";
import "./styles/global.css";
import { Header } from "./components/Header";
import { SpotlightSearch } from "./components/search/SpotlightSearch";
import { LoginNoticeModal } from "./components/LoginNoticeModal";
import { Content } from "./components/layout/Content";
import { Gdpr } from "./components/Gdpr";
import { SEO } from "./components/SEO";
import { AppRoutes } from "./components/routing/AppRoutes";
import { ScrollToTop } from "./components/routing/ScrollToTop";
import { ThemeMeta } from "./components/theme/ThemeMeta";
import { ErrorBoundary } from "./components/ErrorBoundary";
import { Player } from "./components/player/Player";
import { PlaylistModal } from "./components/playlist/PlaylistModal";

configure({
    enforceActions: "never",
});

export const App = () => {
    return (
        <>
            <SEO />
            <MantineProvider
                colorSchemeManager={colorSchemeManager}
                defaultColorScheme="auto"
                theme={theme}
                withGlobalClasses>
                <ThemeMeta />
                <Notifications />
                <AudioProvider>
                    <BrowserRouter>
                        <ErrorBoundary>
                            <>
                                <ScrollToTop />
                                <ErrorBoundary>
                                    <SpotlightSearch />
                                </ErrorBoundary>
                                <Content>
                                    <ErrorBoundary>
                                        <Header />
                                    </ErrorBoundary>
                                    <ErrorBoundary>
                                        <AppRoutes />
                                    </ErrorBoundary>
                                </Content>
                                <ErrorBoundary>
                                    <PlaylistModal />
                                </ErrorBoundary>
                                <ErrorBoundary>
                                    <LoginNoticeModal />
                                </ErrorBoundary>
                                <ErrorBoundary>
                                    <Gdpr />
                                </ErrorBoundary>
                            </>
                        </ErrorBoundary>
                        <ErrorBoundary>
                            <Player />
                        </ErrorBoundary>
                    </BrowserRouter>
                </AudioProvider>
            </MantineProvider>
        </>
    );
};
